import { createContext } from 'react';
import { AlertColor } from '@mui/material/Alert';
export interface iAlert {
    openAlert:boolean,
   
    alertMessage:string,
    alertType:AlertColor
}
export interface iView {
  isPc: boolean;
  isMobile: boolean;
  isTab: boolean;
  setView: (val: any) => void;
  setAlert:(val:any)=>void;
  alert:iAlert
 
}


const SettingContext = createContext<iView>({
  isPc: false,
  isMobile: false,
  isTab: false,
  setView: () => {},
 
  setAlert:()=>{},
 alert:{alertMessage:'',alertType:'error',openAlert:false}

});

export default SettingContext;
